import React, { useMemo } from 'react';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider
} from 'react-router-dom';
import { ProjectCtxProvider } from 'state/project/ProjectCtx';
import { ThemeCtxProvider } from 'state/theme/ThemeCtx';

import { DEFAULT_LOCALE, InitIntl, intlMessages } from 'i18n/languages/locales';
import { HelmetProvider } from 'react-helmet-async';
import { IntlProvider } from 'react-intl';
import { ErrorCtxProvider } from 'state/error/ErrorCtx';
import { FeatureFlagsProvider } from 'contexts/FeatureFlagsContext';
import AppGlobalStyles from './AppGlobalStyles';
import AppQueryClientProvider from './AppQueryClientProvider';
import AppRoutes from './AppRoutes';
import DescopeAuthProviderAppBlocker from './DescopeAuthProviderAppBlocker';
import { env } from './Env/env';
import AuthProviderAppLayout from './Layout/AuthProviderAppLayout';

const Main: React.FC = () => {
	const router = useMemo(
		() =>
			createBrowserRouter(
				createRoutesFromElements(
					<Route
						path="*"
						element={
							<HelmetProvider>
								<ErrorCtxProvider>
									<AppQueryClientProvider>
										<IntlProvider
											locale={DEFAULT_LOCALE}
											messages={intlMessages[DEFAULT_LOCALE]}
										>
											<InitIntl />
											<AppGlobalStyles />
											<ProjectCtxProvider>
												<ThemeCtxProvider>
													<DescopeAuthProviderAppBlocker>
														<FeatureFlagsProvider>
															<AuthProviderAppLayout>
																<AppRoutes />
															</AuthProviderAppLayout>
														</FeatureFlagsProvider>
													</DescopeAuthProviderAppBlocker>
												</ThemeCtxProvider>
											</ProjectCtxProvider>
										</IntlProvider>
									</AppQueryClientProvider>
								</ErrorCtxProvider>
							</HelmetProvider>
						}
					/>
				),
				{
					basename: env.baseRoute || undefined
				}
			),
		[]
	);

	return <RouterProvider router={router} />;
};

export default Main;
